/** Calendar day-of-month ids for `month_on_date`. */
export const RECURRING_MONTH_CALENDAR_DATE_IDS: readonly number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, -1,
];

/** Nth occurrence in month for `month_on_day`. */
export const RECURRING_MONTH_WEEK_OCCURRENCE_IDS: readonly number[] = [
  1, 2, 3, 4,
];

export interface RecurringSelectOption {
  id: number;
  name: string;
}

/**
 * Labels use `calendar.editEventDialog.recurringSettings.ordinal.*` (via `t` scoped with that keyPrefix).
 */
export function buildMonthCalendarDateOptions(
  t: (key: string) => string
): RecurringSelectOption[] {
  return RECURRING_MONTH_CALENDAR_DATE_IDS.map((id) => ({
    id,
    name:
      id === -1
        ? t('ordinal.endOfMonth')
        : t(`ordinal.${id}`),
  }));
}

export function buildMonthWeekOccurrenceOptions(
  t: (key: string) => string
): RecurringSelectOption[] {
  return RECURRING_MONTH_WEEK_OCCURRENCE_IDS.map((id) => ({
    id,
    name: t(`ordinal.${id}`),
  }));
}

export type RecurringType = 'day' | 'week' | 'month' | 'month_on_date' | 'month_on_day';

const ALL_RECURRING_TYPES: readonly RecurringType[] = [
  'day',
  'week',
  'month',
  'month_on_day',
  'month_on_date',
];

interface RecurringTypeOption {
  value: RecurringType;
  label: string;
}

export function buildRecurringTypeOptions(
  recurringCount: number,
  t: (key: string) => string,
  allowedTypes: readonly RecurringType[] = ALL_RECURRING_TYPES
): RecurringTypeOption[] {
  const plural = recurringCount > 1;
  const all: RecurringTypeOption[] = [
    { value: 'day', label: plural ? t('frequencyDays') : t('frequencyDay') },
    { value: 'week', label: plural ? t('frequencyWeeks') : t('frequencyWeek') },
    { value: 'month', label: plural ? t('frequencyMonths') : t('frequencyMonth') },
    { value: 'month_on_day', label: plural ? t('frequencyMonthsOnDay') : t('frequencyMonthOnDay') },
    { value: 'month_on_date', label: plural ? t('frequencyMonthsOnDate') : t('frequencyMonthOnDate') },
  ];
  return all.filter((o) => allowedTypes.includes(o.value));
}
